import { ViewModel,View, ObservableArray } from "binder"
import moment, { min } from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { ReasonTypeSelectorViewModel } from "../returnInvoiceRequestForm/returnInvoiceRequestForm-viewModel";
import { ReturnInvoiceRequestsListViewModel } from "../returnInvoiceRequestsList/returnInvoiceRequestsList-viewModel";
import  { ReturnInvoiceRequestDetailView } from "./returnInvoiceRequestDetail-view"

export class ReturnInvoiceRequestDetailViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ReturnInvoiceRequestsListViewModel, id) {
        super(parentViewModel);
        this.loadById(id);
        this._typedParent = parentViewModel;
        this.lineItems = ObservableArray.create<InvoiceLineItem>();
    }
    GetDefaultView(): View <ViewModel> {
        return new ReturnInvoiceRequestDetailView();
    }
    public getTypeId(): string {
        return "VM-1E6B8B65-064B-40F2-965B-977E85D45DFA"
    }

    private _typedParent : ReturnInvoiceRequestsListViewModel;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName; } private _customerName: string;
    public set customerCode(v: string) { this._customerCode = v; } public get customerCode(): string { return this._customerCode;} private _customerCode: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName; } private _sellerName: string;
    public set invoiceNumber(v: string) { this._invoiceNumber = v; } public get invoiceNumber(): string { return this._invoiceNumber; } private _invoiceNumber: string;
    public set parentInvoiceId(v: string) { this._parentInvoiceId = v; } public get parentInvoiceId(): string { return this._parentInvoiceId;} private _parentInvoiceId: string;
    public set parentInvoiceNumber(v: string) { this._parentInvoiceNumber = v; } public get parentInvoiceNumber(): string { return this._parentInvoiceNumber; } private _parentInvoiceNumber: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName; } private _districtName: string;
    public set deliveryWarehouseId(v: string) { this._deliveryWarehouseId = v; } public get deliveryWarehouseId(): string { return this._deliveryWarehouseId; } private _deliveryWarehouseId: string;
    public set deliveryWarehouseName(v: string) { this._deliveryWarehouseName = v; } public get deliveryWarehouseName(): string { return this._deliveryWarehouseName; } private _deliveryWarehouseName: string;
    public set totalPrice(v: number) { this._totalPrice = v; } public get totalPrice(): number { return this._totalPrice; } private _totalPrice: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice; } private _finalPrice: number;
    public set totalDeficit(v: number) { this._totalDeficit = v; } public get totalDeficit(): number { return this._totalDeficit; } private _totalDeficit: number;
    public set totalAmount(v: number) { this._totalAmount = v; } public get totalAmount(): number { return this._totalAmount;} private _totalAmount: number;
    public set totalAdditions(v: number) { this._totalAdditions = v; } public get totalAdditions(): number { return this._totalAdditions; } private _totalAdditions: number;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set needConfirm(v: boolean) { this._needConfirm = v; } public get needConfirm(): boolean { return this._needConfirm;} private _needConfirm: boolean;
    public set state(v: number) { this._state = v; } public get state(): number { return this._state; } private _state: number;
    public set lineItems(v: ObservableArray<InvoiceLineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<InvoiceLineItem> { return this._lineItems; } private _lineItems: ObservableArray<InvoiceLineItem>;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    async loadById(invoiceId: string) {
        let result = await ServerConnection.callServer('Complex/SellServices/ShowReturnInvoiceRequestDetail', {
            Id: invoiceId,
        });
        this.id = result.Id;
        this.parentInvoiceId = result.InvoiceId;
        this.customerName = result.CustomerName;
        this.customerCode = result.customerCode;
        this.sellerName = result.SellerName;
        this.creationTime = moment.utc(result.CreationTime);
        this.invoiceNumber = result.InvoiceNumber;
        this.parentInvoiceNumber = result.ParentInvoiceNumber;
        this.districtName = result.DistrictName;
        this.state = result.State;
        this.deliveryWarehouseId = result.DeliveryWarehouseId;
        this.deliveryWarehouseName = result.DeliveryWarehouseName;
        this.totalDeficit = 0;
        this.totalAdditions = 0;
        this.lineItems.update(...result.LineItems.map((q,index) => {
            let r = new InvoiceLineItem(this);
            r.rowNumber = index + 1;
            r.saleFromWarehouseId = q.SaleFromWarehouseId;
            r.saleFromWarehouseName = q.SaleFromWarehouseName;
            r.id = q.MeasuredProductId;
            r.productName = q.ProductName;
            r.productCode = q.ProductCode;
            r.productCarModel = q.ProductCarModel;
            r.feePrice = q.FeePrice;
            r.deficit = q.DeficitPrice;
            r.requestReason = q.RequestReason;
            r.isWrecked = q.IsWrecked;
            r.canEdit = false;
            r.needConfirm = this.state === 1;
            r.reasonText = q.ReasonText;
            r.setReasonId(q.FinalReason);
            return r;
        }));
        this.needConfirm = this.state === 1;
    }
    
    removeRow(removedLineItem : InvoiceLineItem) {
        let index = this.lineItems.findIndex(o => o.id == removedLineItem.id && o.saleFromWarehouseId == removedLineItem.saleFromWarehouseId);
        this.lineItems.splice(index,1);
        for (let i = index; i < this.lineItems.length; i++) {
            let element = this.lineItems[i];
            element.rowNumber--;
        }
    }
    
    async createReturnInvoice() {
        try {
            let verificationResult =  this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت فاکتور مرجوعی');
                return;
            }
            let r:string; 
            r = await this.messageBoxWarningYesNo('آیا فاکتور مرجوعی ساخته شود؟','فاکتور مرجوعی');
            if(r=='no'){
                return;
            }
            let result = await ServerConnection.callServer('Complex/SellServices/CreateReturnInvoice', {
                InvoiceId: this.id,
                DeliveryWarehouseId: this.deliveryWarehouseId,
                ReturnInvoiceLineItems: this.lineItems.map(q => {
                    return {
                        MeasuredProductId: q.id,
                        SaleFromWarehouseId: q.saleFromWarehouseId,
                        IsWrecked: q.isWrecked,
                        FeePrice: q.feePrice,
                        DeficitPrice: q.deficit,
                        Comment: q.getReasonId(),
                        ReasonText : q.reasonText
                    }
                })
            });
            if (result.IsSuccessful == true) {
                await this.messageBoxConfirmSuccess(` فاکتور مرجوعی با موفقیت ثبت شد.`, 'عملیات موفق');
            } else {
                if (result.Faults[0].Parameters.FaultId === "58E34570-AD7A-460B-B951-607F26AF8AFB") {
                    throw "این فاکتور قابل مرجوعی نیست.";    
                } else {
                    throw "خطا در ثبت فاکتور";
                }
            }
            this.closePopup();
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex,'خطا');
        } finally {
            this._typedParent.refresh();
        }
    }
   
    verify():string[]{
        let faults :string[] =[];
        let reasons = this.lineItems.filter(x=> undefined == x.getReasonId());
        if(reasons.length>0){
           faults.push(`${reasons.length==1 ? 'سطر' : 'سطرهای'} ${reasons.map(x=>x.rowNumber).join(' و ')} علتش مشخص نشده.`);
        }
        let lowPrice = this.lineItems.filter(x=> x.deficit > x.feePrice);
        if(lowPrice.length>0){
           faults.push(`${lowPrice.length==1 ? 'سطر' : 'سطرهای'} ${lowPrice.map(x=>x.rowNumber).join(' و ')} قیمتش کمتر از تخفیف است.`);
        }
        if(this.lineItems.length === 0){
           faults.push(`هیچ آیتمی وجود ندارد.`);
        }
        return faults;
    }
    
    closePopup() {

    }
}
export class InvoiceLineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ReturnInvoiceRequestDetailViewModel) {
        super(parent);
        this._typedParent = parent;
        this.reasonSelector = new ReasonTypeSelectorViewModel(this);
    }
    private _typedParent : ReturnInvoiceRequestDetailViewModel;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set feePrice(v: number) { 
        this._feePrice = getAsNumber(v,true); 
    } public get feePrice(): number { return this._feePrice; } private _feePrice: number;
    public set deficit(v: number) { this._deficit = v; } public get deficit(): number { return this._deficit; } private _deficit: number;
    public set saleFromWarehouseId(v: string) { this._saleFromWarehouseId = v; } public get saleFromWarehouseId(): string { return this._saleFromWarehouseId; } private _saleFromWarehouseId: string;
    public set saleFromWarehouseName(v: string) { this._saleFromWarehouseName = v; } public get saleFromWarehouseName(): string { return this._saleFromWarehouseName; } private _saleFromWarehouseName: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName; } private _unitName: string;
    public set requestReason(v: string) { this._requestReason = v; } public get requestReason(): string { return this._requestReason;} private _requestReason: string;
    public set needConfirm(v: boolean) { this._needConfirm = v; } public get needConfirm(): boolean { return this._needConfirm;} private _needConfirm: boolean;
    public set canEdit(v: boolean) { this._canEdit = v; } public get canEdit(): boolean { return this._canEdit;} private _canEdit: boolean;
    public set reasonText(v: string) { this._reasonText = v; } public get reasonText(): string { return this._reasonText;} private _reasonText: string;
    public set reasonSelector(v: ReasonTypeSelectorViewModel) { this._reasonSelector = v; } public get reasonSelector(): ReasonTypeSelectorViewModel { return this._reasonSelector;} private _reasonSelector: ReasonTypeSelectorViewModel;
    public set isWrecked(v: boolean) { 
        this._isWrecked = v; 
        this.canEdit = this.needConfirm && v;
    } public get isWrecked(): boolean { return this._isWrecked;} private _isWrecked: boolean;
    
    async removeItem() {
        this._typedParent.removeRow(this);
    }
    
    setReasonId(id: string) {
        this.reasonSelector.selectById(id);
    }

    getReasonId() {
        return this.reasonSelector.selectedItem?.id;
    }
    
}

